import React, { useEffect } from 'react';

import useStyles from 'isomorphic-style-loader/useStyles';
import { Container } from '../../../../../symphony';

import { SlActions } from '../../../services/ActionsService/sl-actions';
import { SlLEContext } from '../../../global-constants';
import {
  ActionType,
  IMaterialProps,
  RequestType,
} from '../../../global-interface';
import { Labels } from '../../Labels/Labels';
import { LPComments } from '../../Comments/LPComments/LPComments';

import s from './LessonPage.scss';

export function LessonPage({ children }: IMaterialProps): JSX.Element {
  useStyles(s);
  useEffect(() => {
    const { actions$ } = Container.take(SlLEContext, SlActions);

    actions$.next({
      type: ActionType.OnLessonPageMount,
      requestType: RequestType.Parallel,
    });

    return () => {
      actions$.next({
        type: ActionType.OnLessonPageUnmount,
        requestType: RequestType.Parallel,
      });
    };
  }, []);

  return (
    <>
      <div sl-test-data="cmpLessonPage" className="le-lesson-page">
        <Labels />
        {children as React.ReactNode}
      </div>
      <LPComments />
    </>
  );
}
